import { useState, useCallback } from 'react';

const useToast = () => {
    const [toasts, setToasts] = useState([]);

    const removeToast = useCallback((id) => {
        setToasts(prev => prev.filter(toast => toast.id !== id));
    }, []);

    const showToast = useCallback((type, message, duration = 2000) => {
        const id = Date.now() + Math.random();
        const newToast = {
            id,
            type,
            message,
            duration
        };

        setToasts(prev => [...prev, newToast]);

        // НЕ удаляем автоматически - пусть компонент сам управляет своим жизненным циклом
        // Компонент Toast сам вызовет onClose после завершения анимации

        return id;
    }, []);

    const hideToast = useCallback((id) => {
        removeToast(id);
    }, [removeToast]);

    // Convenience methods
    const success = useCallback((message, duration) => showToast('success', message, duration), [showToast]);
    const error = useCallback((message, duration) => showToast('error', message, duration), [showToast]);
    const warning = useCallback((message, duration) => showToast('warning', message, duration), [showToast]);
    const info = useCallback((message, duration) => showToast('info', message, duration), [showToast]);

    return {
        toasts,
        showToast,
        hideToast,
        removeToast,
        success,
        error,
        warning,
        info
    };
};

export default useToast;